export default __webpack_public_path__ + "static/EnhanceNews-85a2db7c9aea94e8082dfa1696f2bbb0.png";